import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import { APISource } from '../../../../../../../../typings/Source.interface';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { extractFromArray } from '../../../../../utils';
import { Div } from '../../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { DashboardContext } from '../../DashboardContext';
import DropdownMenu from '../../../../common/DropdownMenu';
import Search from '../../../../common/Search';
import useSearchQuery from '../../../../hooks/useSearchQuery';
import { StyledViewNavSecondary } from '../../../../layouts/ViewLayout';
import ConnectionsList from '../List/ConnectionsList';
import { order_by_options, ResourcesContextProvider } from '../ResourcesContext';
const statuses = {
  active: 'Enabled',
  paused: 'Paused',
  disabled: 'Disabled'
};
export const SourceConnections = t0 => {
  const $ = _c(27);
  const {
    source
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    mutateHasConnection
  } = useContext(DashboardContext);
  const {
    query: t1,
    updateSearchQuery
  } = useSearchQuery();
  const {
    next,
    prev,
    status
  } = t1;
  const t2 = source.id;
  let t3;
  if ($[0] !== status) {
    t3 = extractFromArray(status);
    $[0] = status;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as keyof typeof statuses;
  let t5;
  if ($[2] !== next) {
    t5 = extractFromArray(next);
    $[2] = next;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== prev) {
    t6 = extractFromArray(prev);
    $[4] = prev;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== source.id || $[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
    t7 = {
      source_id: t2,
      status: t4,
      limit: 200,
      next: t5,
      prev: t6
    };
    $[6] = source.id;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const filters = t7;
  let t8;
  if ($[11] !== source.id) {
    t8 = APIMethodKeys.webhooks.count({
      source_id: source.id
    });
    $[11] = source.id;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== HookdeckAPI.webhooks || $[14] !== source.id) {
    t9 = () => HookdeckAPI.webhooks.count({
      source_id: source.id
    });
    $[13] = HookdeckAPI.webhooks;
    $[14] = source.id;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const {
    data: connections_count,
    mutate: mutateConnectionsCount
  } = useSWR(t8, t9);
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      direction: "column"
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== connections_count?.count || $[18] !== filters.limit || $[19] !== filters.status || $[20] !== mutateConnectionsCount || $[21] !== mutateHasConnection || $[22] !== updateSearchQuery) {
    t11 = context => {
      const mutate = () => {
        context.resource_mutation_methods?.webhooks?.mutate();
        mutateConnectionsCount();
        mutateHasConnection();
      };
      const order_by_option = order_by_options[context.order_by || "full_name_asc"] || order_by_options.full_name_asc;
      return <><StyledViewNavSecondary p={{
          b: 3
        }}><Div flex={{
            align: "center",
            gap: 3
          }}><Div w={{
              px: 300
            }}><Search onChange={context.setSearchTerm} value={context.search_term || ""} small={true} placeholder="Filter by ID or name..." /></Div><DropdownMenu icon="filter_list" placement="bottom-start" outline={true} expand_icon="chevron_down" parent_width={{
              min: 200
            }} label={statuses[filters.status] || "Status"} options={[{
              label: "All",
              selected: !filters.status,
              onClick: () => updateSearchQuery({
                status: undefined,
                next: undefined,
                prev: undefined
              })
            }, ...Object.entries(statuses).map(t12 => {
              const [key, label] = t12;
              return {
                label,
                selected: filters.status === key,
                onClick: () => updateSearchQuery({
                  status: [key],
                  next: undefined,
                  prev: undefined
                })
              };
            })]} /></Div><DropdownMenu placement="bottom-end" parent_width={{
            min: 200
          }} outline={true} icon="sort" expand_icon="chevron_down" label_prefix="Order by" label={order_by_option.label} options={Object.entries(order_by_options).map(t13 => {
            const [key_0, t14] = t13;
            const {
              label: label_0
            } = t14;
            return {
              label: label_0,
              selected: context.order_by === key_0,
              onClick: () => context.setOrderBy?.(key_0 as keyof typeof order_by_options)
            };
          })} /></StyledViewNavSecondary><Div style={{
          minHeight: 0,
          flexGrow: 1
        }}><ConnectionsList filtering={!!filters.status || !!context.search_term} view="table" connections={context.webhooks?.models || []} total={connections_count?.count || 0} loading={!context.webhooks} pagination={{
            ...context.webhooks?.pagination,
            page_size: context.webhooks?.pagination?.limit || filters.limit
          }} mutate={mutate} /></Div></>;
    };
    $[17] = connections_count?.count;
    $[18] = filters.limit;
    $[19] = filters.status;
    $[20] = mutateConnectionsCount;
    $[21] = mutateHasConnection;
    $[22] = updateSearchQuery;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== filters || $[25] !== t11) {
    t12 = <Div h={100} flex={t10}><ResourcesContextProvider filters={filters} view="table">{t11}</ResourcesContextProvider></Div>;
    $[24] = filters;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};